// dependencies
import { parseISO } from "date-fns";
import { CreateProcess } from "redux-process";

import EndOfDay from "../../utils/EndOfDay";
// utils
import serializeObject from "../../utils/SerializeObject";

export const getDashboardData = CreateProcess({
	method: "GET",
	name: "GetDashboardData",
	type: "DASHBOARD:DATA",

	request: (props) => {
		const queryParams = serializeObject(props.params, true, {
			arrayKeySuffix: "",
		});

		return {
			url: `/api/dashboard/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response.data;

		// parse dates
		if (data.feedback) {
			data.feedback.forEach((item) => {
				item.date = parseISO(item.date);
			});
		}

		if (data.reviews) {
			data.reviews.forEach((item) => {
				if (item.dueDate || item.completed) {
					if (item.completed) {
						item.dueDate = parseISO(item.completeDate);
					} else {
						item.dueDate = parseISO(item.dueDate);
					}
				}
			});
		}

		if (data.review_forms) {
			data.review_forms.forEach((item) => {
				if (item.dueDate) {
					item.dueDate = parseISO(item.dueDate);
				}
				if (item.complete_date) {
					item.complete_date = parseISO(item.complete_date);
				}
			});
		}

		if (data.todos) {
			data.todos.upcoming.forEach((item) => {
				if (item.due_date) {
					item.due_date = parseISO(item.due_date);
				}
			});
		}

		return response.data.data;
	},
});

export const GetDashboardPermissions = CreateProcess({
	method: "GET",
	name: "GetDashboardPermissions",
	type: "USERS:GET_PERMISSIONS",

	request: (props) => ({
		url: `/api/rbac/permissions/dasbhoard/${props.params.employee_id}/`,
	}),

	success: (response) => {
		const { data } = response;
		const permissions = {};
		const viewableWidgets = [];
		data.user_permissions.forEach((permission) => {
			// format permissions
			const splitPermission = permission.split(":");
			const key = splitPermission[0];
			const value = splitPermission[1];
			if (!permissions[key]) {
				permissions[key] = [value];
			} else {
				permissions[key].push(value);
			}

			// return viewableWidgets
			if (value === "viewWidget") {
				viewableWidgets.push(key);
			}
		});

		return { permissions, viewableWidgets };
	},
});
